import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  icon: {
    display: 'inline-block',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: '50%',
    backgroundColor: theme.palette.grey[100],
  },
}));
